import styled from 'styled-components';

import { Color } from '../../constants/Colors';
import { MediaQuery } from '../../constants/Styles';
import { Typography } from '../../constants/Typographies';

export const NewsletterSection = styled.div`
  border-top: ${({ isSideBlock, isFullScreen }) =>
    !isSideBlock && !isFullScreen && `1px solid ${Color.MYSTIC}`};
  padding-top: ${({ isSideBlock, isFullScreen }) =>
    !isSideBlock && !isFullScreen && '50px'};
  margin: ${({ isSideBlock }) => (isSideBlock ? '0 5px' : '50px 0')};

  ${({ isCustom }) =>
    isCustom &&
    `
    transform: translateY(-80px);

    ${MediaQuery.M_AND_DOWN} {
      transform: translateY(-50px);
    }
  `}

  ${({ isSideBlock }) =>
    isSideBlock &&
    `
    ${MediaQuery.XL_AND_DOWN} {
      margin: 0;
    }
  `}

  ${({ isSideBlock, isFullScreen }) =>
    !isSideBlock &&
    `
    ${MediaQuery.M_AND_DOWN} {
      margin: 60px 15px;
      padding-top: ${!isFullScreen && `60px`};
    }
  `}
`;

export const ModalContent = styled.div``;

export const ModalTitle = styled.p`
  ${Typography.XL_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin: 20px 0;
`;
